<ng-container *transloco="let t">
  <div
    (click)="toggleAccordion()"
    class="flex flex-col font-normal dark:bg-containerBg text-mainTextLight dark:text-mainTextLight">
    <div
      [class]="
        '  w-full min-h-14 md:min-h-12 flex justify-between cursor-pointer overflow-hidden z-[4] items-center  dark:bg-[#2C145E] px-4 py-2 rounded-xl  ' +
        (closed && !isAdvent ? '  bg-skyBtnHoverLight z-20 ' : ' ') +
        (!white ? 'bg-inputBackground ' : 'bg-white ') +
        (closed && !white && !isAdvent ? ' shadow-md box-shadow' : '') +
        (isAdvent ? ' ' : 'dark:hover:bg-containerBg hover:bg-skyBtnHoverLight ')
      ">
      <span [class]="'text-left ' + (isAdvent ? 'text-sm md:text-base !leading-5 font-semibold ' : 'text-base md:text-lg ')">
        {{ isInner ? index + '. ' + name : name }}
      </span>
      <div class="flex gap-5 items-center">
        <div
          *ngIf="!closed"
          class="dark:text-secondaryTextMain text-3xl font-light text-secondaryTextLight dark:bg-containerBg bg-containerBgLight rounded-full w-8 h-8 flex items-center justify-center">
          <img src="https://cdn.chipychapa.com//welle/General_site/Sidebar/FAQ/open_FAQ.svg" alt="open_FAQ" />
        </div>
        <div
          *ngIf="closed"
          class="dark:text-secondaryTextMain text-3xl font-light text-secondaryTextLight dark:bg-containerBg bg-containerBgLight rounded-full w-8 h-8 flex items-center justify-center">
          <img src="https://cdn.chipychapa.com//welle/General_site/Sidebar/FAQ/close_FAQ.svg" alt="close_FAQ" />
        </div>
      </div>
    </div>
    @if (isAdvent && closed) {
      <div class="w-full px-4">
        <hr class="h-px w-full border-defaultIcon" />
      </div>
    }
  </div>
  <div
    [class]="
      'transition-all ease-in-out duration-500 overflow-hidden rounded-b-xl text-sm md:text-base ' +
      (!closed ? 'max-h-0 mb-4' : 'max-h-screen pt-6 md:pt-8 pb-4') +
      ' px-3 md:px-6 -mt-4 z-0 flex flex-col no-scrollbar ' +
      (!white ? 'bg-inputBackground' : 'bg-white')
    ">
    <ng-content></ng-content>
  </div>
</ng-container>
